import { Reveal, Overline } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "What is the difference between a patent and a trademark?", a: "A patent protects an invention — how something works or is made — for a limited term (typically 20 years). A trademark protects brand identifiers such as names, logos and slogans, and can be renewed indefinitely. Most growing businesses need both." },
  { q: "Can you file outside India?", a: "Yes. We file directly before the Indian patent, trademark, design and copyright offices, and secure international protection through PCT international patent applications, Madrid System trademark filings and national-phase entries in the markets you care about." },
  { q: "How long does registration take?", a: "Trademarks typically register in 6–12 months depending on the office. Patents take longer — 2 to 5 years through examination — though provisional and priority filings lock in your rights from day one." },
  { q: "What do official fees cost on top of your professional fees?", a: "Official fees are set by each patent or trademark office and vary by jurisdiction and application type. Every quote we issue itemises official fees separately from professional fees, so there are never any surprises." },
  { q: "How do I track my applications?", a: "Every client gets access to the Claimspace portal, where each filing shows its live status — filed, under examination, published, granted or registered — with references and renewal dates." },
  { q: "Do you handle office actions and oppositions?", a: "Yes. Examination reports, office actions, oppositions and hearings are all handled by our attorneys, with local counsel engaged where a jurisdiction requires it." },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-32">
      <div className="max-w-4xl mx-auto px-6 sm:px-8">
        <Reveal className="mb-14">
          <Overline>Questions, answered</Overline>
          <h2 className="font-serif font-light tracking-tight text-4xl sm:text-5xl leading-tight">
            Before you <span className="italic text-gold">ask.</span>
          </h2>
        </Reveal>
        <Reveal>
          <Accordion type="single" collapsible data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-gold/20" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-serif text-xl sm:text-2xl text-white hover:text-gold hover:no-underline py-6 transition-colors">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-mist leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
